import { render, staticRenderFns } from "./ProductGiftCertificate.vue?vue&type=template&id=2cd19f04"
import script from "./ProductGiftCertificate.vue?vue&type=script&lang=js"
export * from "./ProductGiftCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports